import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import request from "../../../Helpers/API";
import { AgruparByProp } from "../../../Helpers/Agrupaciones/AgruparByProp";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { TotalizarByProp } from "../../../Helpers/Agrupaciones/TotalizarByProp";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import UpdateIcon from "@mui/icons-material/Update";
import { TotalCarteraClientesComentarios } from "./TotalCarteraClientesComentarios";
import ReporteCliente from "./PDF/TotalCarteraClientePDF";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";

//estilos para el boton de PDF
const styles = {
  pdfDownloadLink: {
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100px",
    height: "25px",
    borderRadius: "5px",
    marginLeft: "10px",
    marginRight: "10px",
    backgroundColor: "#940404",
    cursor: "pointer",
    boxShadow: "3px 3px 3px #333",
    color: "rgba(255, 255, 255, 0.8)",
  },
};

export const TotalCarteraCliente = () => {
  const location = useLocation();
  const history = useHistory();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [state, setState] = useState({
    data: [],
    lineas: [],
    estado: [],
  });
  useEffect(() => {
    Actualizar();
  }, []);
  const Actualizar = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `TotalCarteraDetalle/ListadoPorCliente?cliente=${Number(
          location.state.cliente,
        )}`,
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setState({
          data: result,
          lineas: AgruparByProp(result, "linea"),
          estado: AgruparByProp(result, "estatus"),
        });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        console.log(error);
      });
  };
  const onHome = () => {
    history.push("/Creditoycobranza/TotalCarteraDetalle", {
      idsucursal: location.state.idsucursal,
      linea: location.state.linea,
    });
  };
  const onGeneraExcel = () => {
    // var idsucursal = Number(location.state.idsucursal);
    // var linea = location.state.linea
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `TotalCarteraDetalle/GenerarExcelCliente?cliente=${Number(
          location.state.cliente,
        )}`,
      )
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
      });
  };

  const PDFDownloadButton = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `TotalCarteraDetalle/ReporteDetalleClientePDF?cliente=${Number(
          location.state.cliente,
        )}`,
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };

  const capitalizeWords = (str) => {
    return str
      ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())
      : "";
  };

  return (
    <div className="cartera-detalle-clientes">
      <LoaderScreen loader={loader} />
      <header className="cartera-detalle-clientes-encabezado">
        <div className="title">
          <div
            className="buton-cobranza-clientes-detalle"
            onClick={() => onHome()}
          >
            <ArrowBackIosIcon /> Regresar
          </div>
          CARTERA DETALLE DE {location.state.razonsocial}
        </div>
        <div className="buttons">
          <button onClick={() => Actualizar()} className="actualizar">
            <UpdateIcon /> Actualizar
          </button>
          <button className="excel" onClick={() => onGeneraExcel()}>
            <i className=" icon-file-excel" /> Excel
          </button>
          <button
            className="PDF"
            onClick={() => PDFDownloadButton()}
            style={{ backgroundColor: "#940404" }}
          >
            PDF
          </button>
        </div>
      </header>
      <div className="cartera-detalle-clientes-detalle">
        <div className="cartera-detalle-clientes-detalle-tabla scroll">
          <table cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th>Sucursal</th>
                <th>
                  <div>Documento</div>
                </th>
                <th>
                  <div>Vencimiento</div>
                </th>
                <th>
                  <div>Días</div>
                </th>
                <th>
                  <div>Importe</div>
                </th>
                <th>
                  <div>Intereses</div>
                </th>
                <th>
                  <div>Total</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {state.estado.map((estado) => (
                <>
                  <tr className="row-encabezado">
                    <td>{capitalizeWords(estado)}</td>
                    <td></td>
                    <td>{capitalizeWords(estado)}</td>
                    <td></td>
                    <td>
                      {FormatMoney(
                        TotalizarByProp(
                          state.data.filter((item) => item.estatus === estado),
                          "saldo",
                        ),
                      )}
                    </td>
                    <td>
                      {FormatMoney(
                        TotalizarByProp(
                          state.data.filter((item) => item.estatus === estado),
                          "interesbase",
                        ),
                      )}
                    </td>
                    <td>
                      {FormatMoney(
                        TotalizarByProp(
                          state.data.filter((item) => item.estatus === estado),
                          "importe",
                        ),
                      )}
                    </td>
                  </tr>
                  {state.lineas.map((linea) => (
                    <>
                      <tr className="row-encabezado">
                        <td>{capitalizeWords(linea)}</td>
                        <td></td>
                        <td>{capitalizeWords(linea)}</td>

                        <td></td>
                        <td>
                          {FormatMoney(
                            TotalizarByProp(
                              state.data.filter(
                                (item) =>
                                  item.estatus === estado &&
                                  item.linea === linea,
                              ),
                              "saldo",
                            ),
                          )}
                        </td>
                        <td>
                          {FormatMoney(
                            TotalizarByProp(
                              state.data.filter(
                                (item) =>
                                  item.estatus === estado &&
                                  item.linea === linea,
                              ),
                              "interesbase",
                            ),
                          )}
                        </td>
                        <td>
                          {FormatMoney(
                            TotalizarByProp(
                              state.data.filter(
                                (item) =>
                                  item.estatus === estado &&
                                  item.linea === linea,
                              ),
                              "importe",
                            ),
                          )}
                        </td>
                      </tr>
                      {state.data
                        .filter(
                          (item) =>
                            item.estatus === estado && item.linea === linea,
                        )
                        .map((item) => (
                          <tr className="row-detalle" onClick={() => {}}>
                            <td>{capitalizeWords(item.sucursal)}</td>
                            <td>{item.documento}</td>
                            <td>{item.vencimiento}</td>
                            <td>{item.diasvencido}</td>
                            <td>{FormatMoney(item.saldo)}</td>
                            <td>{FormatMoney(item.interesbase)}</td>
                            <td>$ {FormatMoney(item.importe)}</td>
                          </tr>
                        ))}
                      <tr className="row-espacio">
                        <td colSpan={7}></td>
                      </tr>
                    </>
                  ))}
                </>
              ))}

              <tr className="row-encabezado">
                <td></td>
                <td>Totales:</td>
                <td></td>
                <td></td>
                <td>{FormatMoney(TotalizarByProp(state.data, "saldo"))}</td>
                <td>
                  {FormatMoney(TotalizarByProp(state.data, "interesbase"))}
                </td>
                <td>{FormatMoney(TotalizarByProp(state.data, "importe"))}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* <TotalCarteraClientesComentarios idcliente={location.state.cliente} /> */}
      </div>
    </div>
  );
};
